import rsa from "./rsa.js";

module.exports = class ecdsa extends rsa {};



// WEBPACK FOOTER //
// ./frontend/connection_tests/ecdsa.js